import MouseWatcher from './MouseWatcher';

export default MouseWatcher;